import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ViewLeadPopupComponent } from '../view-lead-popup/view-lead-popup.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  expandedRow: number | null = null;
  expandedIndex: number | null = null;
  model: { year: number, month: number, day: number };
  billing = [];
  

  constructor(private rsbService: RsbService,
    public lookupModel: RsbLookupModel,
    private router: Router
  ) { }
  dropdownVisible = false;
  dropdownIndex: number | null = null;
  dropdownPosition = { top: 0, left: 0 };
  ngOnInit(): void {
    this.getBilling()
  }

  toggleRow(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  getBilling(): void {
    this.rsbService.getBillingOfFranchise({status:7}).subscribe((rsp)=> {
      this.billing = rsp.contents
    })
  }



  toggleDropdown(event: MouseEvent, index: number): void {
    event.stopPropagation(); // Prevent document click from immediately closing it

    const clickedSame = this.dropdownIndex === index && this.dropdownVisible;

    if (clickedSame) {
      this.dropdownVisible = false;
      this.dropdownIndex = null;
    } else {
      const target = (event.target as HTMLElement).closest('.ellipsis');
      const rect = target?.getBoundingClientRect();
      this.dropdownVisible = true;
      this.dropdownIndex = index;

      if (rect) {
        this.dropdownPosition = {
          top: rect.top + window.scrollY + 20,
          left: rect.left + window.scrollX - 100,
        };
      }
    }
  }


}
